<script setup lang="ts">
const props = withDefaults(defineProps<{
  isOpen: boolean,
  submitLabel?: string,
  cancelLabel?: string,
  disabledSubmit?: boolean,
  closeOnSubmit?: boolean,
  closeOnCancel?: boolean,
  showSubmit?: boolean,
  uiModal?: any
  uiCard?: any,
  closeCross?: boolean,
  dirFooter?: 'ltr' | 'rtl'
}>(), {
  submitLabel: 'Default submit label',
  cancelLabel: 'Fermer',
  disabledSubmit: false,
  closeOnSubmit: true,
  closeOnCancel: true,
  showSubmit: true,
  uiModal: {},
  uiCard: {},
  closeCross: true,
  dirFooter: 'ltr'
})

const emit = defineEmits<{
 (e: 'update:isOpen', value: boolean): void,
 (e: 'submitHandler'): void,
 (e: 'cancelHandler'): void,
}>()

const isOpen = computed({
  get () {
    return props.isOpen
  },
  set (value) {
    emit('update:isOpen', value)
  }
})

const closeOnSubmit = computed(() => props.closeOnSubmit)
const closeOnCancel = computed(() => props.closeOnCancel)

const submitHandler = () => {
  emit('submitHandler')

  if (closeOnSubmit.value) {
    emit('update:isOpen', false)
  }
}

const cancelHandler = () => {
  emit('cancelHandler')

  if (closeOnCancel.value) {
    emit('update:isOpen', false)
  }
}
</script>

<template>
  <UModal v-model="isOpen" :ui="{ base: '', container: 'flex min-h-full items-end sm:items-center justify-center text-left', width: 'sm:max-w-3xl', ...uiModal }">
    <UCard :ui="{ divide: 'divide-y divide-gray-100 dark:divide-gray-800', header: { base: 'text-base font-semibold leading-6 text-gray-900' }, ...uiCard }">
      <template #header>
        <div v-if="closeCross" class="flex items-center justify-between">
          <slot name="header" />
          <UButton
            color="gray"
            variant="ghost"
            icon="i-heroicons-x-mark-20-solid"
            class="-my-1"
            tabindex="3"
            @click="isOpen = false"
          />
        </div>
        <slot v-else name="header" />
      </template>

      <slot />

      <template #footer>
        <slot name="footer">
          <div :class="showSubmit ? 'sm:grid-cols-2' : 'sm:grid-cols-1'" class="sm:grid sm:grid-flow-row-dense sm:gap-3" :dir="dirFooter">
            <slot name="cancel">
              <ButtonModalCancel tabindex="1" @click="cancelHandler">
                {{ cancelLabel }}
              </ButtonModalCancel>
            </slot>
            <slot name="submit">
              <ButtonModalSubmit v-if="showSubmit" :disabled="disabledSubmit" tabindex="2" @click="submitHandler">
                {{ submitLabel }}
              </ButtonModalSubmit>
            </slot>
          </div>
          <slot name="footer-content" />
        </slot>
      </template>
    </UCard>
  </UModal>
</template>
